// @ts-nocheck
import Card from "atoms/card/card";
import Divider from "atoms/divider/divider";
import Heading from "atoms/heading/heading";
import Sheet from "atoms/sheet/sheet";
import SheetBody from "atoms/sheet/sheetBody/sheetBody";
import * as dynamicGridSagaActions from "models/dynamicGrid/sagaActions";
import * as dynamicGridSelectors from "models/dynamicGrid/selector";
import * as tableColumnSagaActions from "models/tableColumns/sagaActions";
import * as tableColumnSelectors from "models/tableColumns/selector";
import SideCar from "molecules/sidecar/sidecar";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import CustomizeViewModal from "organisms/CustomizeViewModal";
import ThetaMenu from "organisms/thetaMenu/thetaMenu";
import UploadData from "organisms/uploadData";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ThetaGridPaginated from "templates/thetaGridPaginated";
import * as constants from "./constants";
import Breadcrumbs from "atoms/breadcrumbs/breadcrumbs";
import ThetaDeleteModal from "organisms/deleteModal/deleteModal";
import ExportGrid from "organisms/exportGrid";
import ToggleAgGrid from "organisms/toggleAgGrid";
import { REQUESTS } from "utils/services/thetaretail/requests";
import {
  isMasterDataItemsWrite,
  isPlanogramRestrictionsWriteEnabled,
} from "models/user/selector";
import { isMasterDataItemsDelete } from "../../../models/user/selector";
import GridActionBar from "atoms/GridActionBar";
import GridCsvUpload from "organisms/uploadData/gridCsvUpload";
import { isNewUploadEnabled } from "models/user/selector";
import Button from "atoms/button/button";
import Tab from "atoms/tab/tab";
import {
  togglePlanogramState,
  togglePlanogramAttributeState,
} from "./sagaActions";
import CreatePlanogram from "./createPlanogram";
import { Switch, Tooltip, Typography } from "antd";
import { createFiltersFromQueries } from "models/dynamicGrid/query";
import { fetchBookmarksList } from "models/bookmarks/sagaActions";
import { setActiveUploadPageName } from "./reducer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { Button as AntButton } from "antd";

const ITEMS_MODAL = "items-modal";

const { Title } = Typography;

const PlanogramListing: React.FunctionComponent = (props) => {
  const [openFilter, setOpenFilter] = React.useState<boolean>();
  const [isUploadEnabled, toggleUpload] = React.useState<boolean>(false);
  const [isDeleteModal, toggleDeleteModal] = React.useState(false);
  const [isGridUpload, setGridUpload] = React.useState(false);

  const gridMeta = useSelector((state) =>
    dynamicGridSelectors.getGridMetadata(state, constants.TABLE_ID)
  );
  const tableId = constants.TABLE_ID.toString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasWriteAccess = useSelector(isMasterDataItemsWrite);
  const hasDeleteAccess = useSelector(isMasterDataItemsDelete);
  const hasSearchFilters = useSelector((state) =>
    dynamicGridSelectors.hasSearchFilters(state, constants.TABLE_ID)
  );
  const isPlanogramWrite = useSelector(isPlanogramRestrictionsWriteEnabled);
  const isCustomizeViewModalEnabled = useSelector((state) =>
    tableColumnSelectors.isCustomizeViewModalEnabled(state)
  );

  const handleFilterClick = React.useCallback(() => {
    setOpenFilter(!openFilter);
  }, [openFilter]);

  const handleRefreshClick = React.useCallback(() => {
    dispatch(
      dynamicGridSagaActions.refreshGridData({
        tableId: constants.TABLE_ID,
      })
    );
  }, [tableId, dispatch]);

  const handleBackClick = React.useCallback(() => {
    navigate(`/masterData`);
  }, [navigate]);

  const handleResetTableColumns = React.useCallback(async () => {
    dispatch(tableColumnSagaActions.resetTableColumnsAg(constants.TABLE_ID));
  }, [dispatch, tableId]);

  const customizeViewHandler = React.useCallback(
    (isCustomizeViewModalEnabled: boolean) => {
      dispatch(
        tableColumnSagaActions.setCustomizeViewModal(
          isCustomizeViewModalEnabled
        )
      );
    },
    []
  );

  React.useEffect(() => {
    dispatch(
      dynamicGridSagaActions.erpEnabled({ tableId: constants.TABLE_ID })
    );
    dispatch(fetchBookmarksList({ tableId: constants.TABLE_ID }));
  }, [dispatch]);

  const handleMenuItemClick = React.useCallback(
    (option: string) => {
      switch (option) {
        case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
          return customizeViewHandler(true);
        case constants.MENU_ITEMS_VALUES.RESET_VIEW:
          return handleResetTableColumns();
        case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
          return toggleUpload(true);
        case constants.MENU_ITEMS_VALUES.DELETE:
          return deleteItems();
        default:
          return;
      }
    },
    [handleResetTableColumns]
  );

  const selectedItems = useSelector((state) =>
    dynamicGridSelectors.getTableSelection(state, constants.TABLE_ID)
  );
  const getDisabledStatus = React.useCallback(
    (option: any) => {
      switch (option.value) {
        case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
        case constants.MENU_ITEMS_VALUES.RESET_VIEW:
        case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
          return false;
        case constants.MENU_ITEMS_VALUES.DELETE:
          return !selectedItems?.selectedRowKeys?.length;
        default:
          return true;
      }
    },
    [selectedItems]
  );

  const hideCustomizeViewModal = React.useCallback(() => {
    customizeViewHandler(false);
  }, []);

  const uploadCloseClickHandler = React.useCallback(() => {
    toggleUpload(false);
  }, []);

  const searchQuery = useSelector((state) =>
    dynamicGridSelectors.getGridFilters(state, constants.TABLE_ID)
  );
  const tableSelection = useSelector((state) =>
    dynamicGridSelectors.getTableSelection(state, constants.TABLE_ID)
  );

  const handleBulkDeleteClick = () => {
    dispatch(
      togglePlanogramState({
        // row,
        selection: tableSelection?.selectedRowKeys,
        isBulkUpdate: true,
        isActive: false,
        isSelectAll: tableSelection?.isSelectAll,
        selectAllSearch: JSON.stringify({
          filter: createFiltersFromQueries(searchQuery?.search, true),
        }),
      })
    );
    toggleDeleteModal(false);
  };

  const deleteItems = () => {
    toggleDeleteModal(true);
  };
  const isNewUpload = useSelector(isNewUploadEnabled);

  const gridConfig = {
    enableSelection: true,
    enableSorting: true,
    enableMultiSort: true,
    gridActions: hasDeleteAccess,
    rowHeight: 100,
    customActions: {
      width: 150,
      enabled: true,
      component: ({ row }) => {
        return (
          <Stack gutter="medium" align="center" divisions={2}
>
            <StackItem span={1} position="center">
              <Switch
                checked={row?.IsActive}
                size="small"
                onClick={() => {
                  dispatch(
                    togglePlanogramState({
                      row,
                      id: row?.PlanogramID,
                      isActive: !row?.IsActive,
                    })
                  );
                }}
              />
            </StackItem>
            <StackItem span={1}>
              <Button
                size="small" 
                handleClick={() => {
                  navigate(`/planogram/details/${row?.PlanogramID}`);
                }}
              >
                Details
              </Button>
            </StackItem>
          </Stack>
        );
      },
    },
    childGridActions: ["delete"],
    selectionCallBack: () => {},
  };

  const templateConfig = {
    gridConfig,
    isFilterEnabled: openFilter === undefined ? false : openFilter,
    tableId: constants.TABLE_ID,
    dataProviderOptions: {
      type: "POST",
      ...REQUESTS.POST.GET_GRID_DETAILS_V2,
      pathParams: { tableId: constants.TABLE_ID },
      version: 2,
    },
    selectRowKey: "PlanogramID",
    childTableSelectRowKey: "PlanogramAttributeDistributionID",
  };

  return (
    <>
      <Stack isVertical>
        <StackItem>
          <GridActionBar>
            <div className="content-head">
              <Stack gutter="medium" align="right">
                {/* <div className="content-head-lt">
                  <Title level={3}>Planogram List</Title>
                  <Title level={5}>Display text here</Title>
                </div> */}
                <StackItem className="content-head-rt">
                  <Stack gutter="medium" className="action-btns">
                    <StackItem>
                      {/* <Button
                        isPrimary
                        size="small"
                        name={"Create Planogram"}
                        handleClick={() => {
                          setGridUpload(true);
                          dispatch(
                            setActiveUploadPageName({
                              pageName: constants.UPLOAD_PAGES.STORES,
                            })
                          );
                        }}
                      >
                        <Stack
                          align="space-between"
                          gutter="small"
                          position="center"
                        >
                          <StackItem isGrow align="center">
                            Create Planogram
                          </StackItem>
                          <StackItem isStretch>
                            <Divider size="small" isVertical></Divider>
                          </StackItem>
                          <StackItem>
                            <Icon
                              disabled={false}
                              isPadded={false}
                              faAlias="faPlus"
                              size="tiny"
                            />
                          </StackItem>
                        </Stack>
                      </Button> */}
                      <Button
                        type="primary"
                        name={"Create Planogram"}
                        handleClick={() => {
                          setGridUpload(true);
                          dispatch(
                            setActiveUploadPageName({
                              pageName: constants.UPLOAD_PAGES.STORES,
                            })
                          );
                        }}
                      >
                        <i className="icon-add" /> Create Planogram
                      </Button>
                    </StackItem>
                    <StackItem className="action-btn">
                      <Tooltip title="Refresh"> <AntButton
                        className="menu-action--button"
                        icon={
                          <FontAwesomeIcon
                            className="font-icon"
                            icon={faArrowsRotate}
                          />
                        }
                        onClick={handleRefreshClick}
                      /></Tooltip>
                    </StackItem>
                    <StackItem className="action-btn">
                      <Tooltip title="More Options"> <ThetaMenu
                        type="3Dots"
                        options={
                          hasWriteAccess
                            ? constants.MENU_ITEMS
                            : [constants.MENU_ITEMS[0]]
                        }
                        handleItemClick={handleMenuItemClick}
                        isDisabled={getDisabledStatus}
                      /></Tooltip>
                    </StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </div>
          </GridActionBar>
        </StackItem>
        <StackItem isStretch isGrow className="order-tbl">
          <SheetBody>
            <Stack isVertical>
              <StackItem isStretch isGrow>
                <Sheet isPage>
                  <Stack isVertical gutter="tiny">
                    {isPlanogramWrite && (
                      <StackItem isStretch align="right">
                        <CreatePlanogram
                          isGridUpload={isGridUpload}
                          setGridUpload={setGridUpload}
                        />
                      </StackItem>
                    )}
                    <StackItem isGrow isStretch>
                      <ThetaGridPaginated
                        key={constants.TABLE_ID}
                        config={templateConfig}
                      />
                    </StackItem>
                  </Stack>
                </Sheet>
              </StackItem>
            </Stack>
          </SheetBody>
        </StackItem>
      </Stack>

      {isCustomizeViewModalEnabled && (
        <CustomizeViewModal
          hideModal={hideCustomizeViewModal}
          tableId={constants.TABLE_ID}
        />
      )}
      {isUploadEnabled && (
        <SideCar
          isActive={isUploadEnabled}
          handleOnClose={uploadCloseClickHandler}
        >
          <UploadData tableId={tableId} />
        </SideCar>
      )}
      {isDeleteModal && (
        <ThetaDeleteModal
          hideModal={() => {
            toggleDeleteModal(false);
          }}
          modalTitle={"ITEMS"}
          title={` (${
            selectedItems?.isSelectAll
              ? "All"
              : selectedItems?.selectedRowKeys?.length
          }) selected  item(s)`}
          handleDeleteClick={handleBulkDeleteClick}
          isLocked={true}
        />
      )}
    </>
  );
};
export default PlanogramListing;
